export default [
    {
        value: "NotaFiscal",
        text: "Nota fiscal"
    },
    {
        value: "OrdemPagamento",
        text: "Ordem de pagamento"
    },
    {
        value: "Outros",
        text: "Outros"
    },
]